import React, { useState } from 'react';
import { FaEllipsisV } from 'react-icons/fa'; // 3-dot vertical menu icon

const TemplatesItem = ({ title, description, onClick, onDelete }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = (e) => {
    e.stopPropagation(); // Prevent triggering the parent `onClick` event
    setMenuOpen(!menuOpen);
  };

  const handleDelete = (e) => {
    e.stopPropagation(); // Prevent triggering the parent `onClick` event
    onDelete(); // Trigger the delete action passed from Home.js
  };

  return (
    // <div onClick={onClick} style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px', marginBottom: '10px', cursor: 'pointer', position: 'relative' }}>
    <div
      style={{
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        marginBottom: '10px',
        cursor: 'pointer',
        position: 'relative',
      }}
    >
      <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{title}</div>
      {/* <div style={{ fontSize: '12px', color: '#888' }}>{description}</div> */}

      {/* 3-dot vertical menu */}
      {/* <div onClick={handleMenuToggle} style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }}>
        <FaEllipsisV />
      </div> */}

      {/* Dropdown menu */}
      {/* {menuOpen && (
        <div style={{
          position: 'absolute',
          top: '30px',
          right: '10px',
          border: '1px solid #ddd',
          backgroundColor: '#fff',
          borderRadius: '4px',
          zIndex: 100,
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
        }}>
          <div onClick={onClick} style={{ padding: '8px', cursor: 'pointer' }}>Open</div>
          <div onClick={handleDelete} style={{ padding: '8px', cursor: 'pointer', color: 'red' }}>Delete</div>
        </div>
      )} */}
    </div>
  );
};

export default TemplatesItem;
